const EMPLOYEE_ACTIONS = {
    VIEW: {
        text: 'details',
        icon: 'mdi-eye',
        route: 'employeeDetails'
    },
    EDIT_DOCUMENTS: {
        text: 'edit document files',
        icon: 'fa-file-alt',
        route: 'employeeDocumentFilesEdit'
    },
    ADD_DOCUMENTS: {
        text: 'add document files',
        icon: 'fa-file-alt',
        route: 'employeeDocumentFilesAdd'
    },
    EDIT: {
        text: 'edit',
        icon: 'ub-employee',
        route: 'employeeEdit'
    },
    DELETE:{
        text: 'delete',
        icon: 'mdi-delete'
    },
    ADD:{
        route: 'employeeAdd'
    }
};

export {
    EMPLOYEE_ACTIONS,
}